import React, {useEffect, useRef, useState} from "react";
import {useIsOpenSidebar, useIsOpenSidebarAction} from "../../context/toggleSidebarContext";
import {useAuth} from "../../context/AuthContext";
import {logout, setReturnToAdmin} from "../../services";
import {Link, useNavigate} from "react-router-dom";
import Loading from "../Loading";

export default function Header(data) {
    const [isShowDropdownUser, setIsShowDropdownUser] = useState(false);
    const [isShowDropdownNotification, setIsShowDropdownNotification] = useState(false);
    const [isShowDropdownLanguage, setIsShowDropdownLanguage] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const dropdownUserRef = useRef(null);
    const dropdownNotificationRef = useRef(null);
    const dropdownLanguageRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const setIsOpenSidebar = useIsOpenSidebarAction()
    const isOpenSidebar = useIsOpenSidebar();

    const auth = useAuth();

    useEffect(() => {
        document.addEventListener('mousedown', handleDropdownUser);
        document.addEventListener('mousedown', handleDropdownNotification);
        document.addEventListener('mousedown', handleDropdownLanguage);
        window.addEventListener("scroll", handleScroll);

        return () => {
            document.removeEventListener('mousedown', handleDropdownUser);
            document.removeEventListener('mousedown', handleDropdownLanguage);
            document.removeEventListener('mousedown', handleDropdownNotification);
            window.removeEventListener("scroll", handleScroll);
        };


    }, [])

    const handleScroll = () => {
        if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false)
        }
    }

    const handleDropdownUser = (e) => {
        if (dropdownUserRef?.current && !dropdownUserRef.current.contains(e.target)) {
            setIsShowDropdownUser(false)
        }
    }
    const handleDropdownNotification = (e) => {
        if (dropdownNotificationRef?.current && !dropdownNotificationRef.current.contains(e.target)) {
            setIsShowDropdownNotification(false)
        }
    }
    const handleDropdownLanguage = (e) => {
        if (dropdownLanguageRef?.current && !dropdownLanguageRef.current.contains(e.target)) {
            setIsShowDropdownLanguage(false)
        }
    }
    const handelReturnAdmin = () => {
        localStorage.setItem('token', null);
        localStorage.setItem('adminToken', null);
        window.location.href = process.env.REACT_APP_KAR_URL_KEY;
    }
    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const {isSuccess} = await logout();
            if (isSuccess) {
                navigate('/login')
            }
            setIsLoading(false)
        } catch (ex) {
            console.log(ex);
            setIsLoading(false);
        }
    }

    return (
        <>
            <nav
                className={`layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme ${isScrolled ? "navbar-elevated" : ""}`}
                id="layout-navbar">
                <div className="container-fluid">

                    <div
                        className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none zindex-5 text-white"
                        onClick={() => setIsOpenSidebar({...isOpenSidebar, expanded: true})}>
                        <button className="nav-item nav-link px-0 me-xl-4 bg-transparent border-0 text-white">
                            <i className="bx bx-menu bx-sm text-white"/>
                        </button>
                    </div>
                    <span style={{width: '100px', right: 'calc(50% - 50px)'}} className={"text-center position-absolute topName font-12"}>

                        <img src="/images/logo11.webp" className={"w-px-100 me-2 "}/>
                    </span>

                    <div className="navbar-nav-right d-flex m-0 w-fit-content">
                        <ul className="navbar-nav flex-row align-items-center ms-auto m-0 w-fit-content m-0">
                            <li className="nav-item me-2 me-xl-0">

                                <button className="nav-link style-switcher-toggle hide-arrow border-0 bg-transparent">
                                    <div className="text-white">{!((localStorage.getItem('adminToken') === 'null') || (localStorage.getItem('adminToken') === null)) ?
                                        <span onClick={handelReturnAdmin}>ادمین<i
                                            className="bx  bx-arrow-back"/> </span> : ""}</div>
                                </button>
                            </li>


                            <li className="nav-item ">
                                { auth && data.layout === "user" ?
                                    <span className={"font-12 zindex-5 position-relative "} style={{cursor: 'pointer'}} onClick={()=>navigate('/adv-panel')}>داشبورد</span>
                                    :
                                !auth ?
                                    <span className={"font-12 zindex-5 position-relative"} style={{cursor: 'pointer'}} onClick={()=>navigate('/login')}>ورود | ثبت نام</span>
                                    :
                                    null
                                }
                            </li>

                        </ul>
                    </div>

                </div>
            </nav>
            {
                isLoading ? (<Loading/>) : null
            }
        </>
    )
}